import ErrorMessage from "legacy/ErrorMessage"
import { handleInputChange, titleCase } from "legacy/helpers.es6"
import FeesAndDiscountsForm from "legacy/manage/FeesAndDiscountsForm"
import ItinerarySection from "legacy/new-reservation-form/ItinerarySection"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class EditReservationModal extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      showModal: false,
      arrival: this.props.arrival,
      departure: this.props.departure,
      revenueCategoryId: this.props.revenueCategoryId,
      feesAndDiscounts: this.props.feesAndDiscounts || [],
      spaceType: this.props.spaceType,
      boaterNotification: true,
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.save = this.save.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleArrivalChange = this.handleArrivalChange.bind(this)
    this.handleDepartureChange = this.handleDepartureChange.bind(this)
    this.updateFeesAndDiscounts = this.updateFeesAndDiscounts.bind(this)
    this.feesAndDiscountsRef = React.createRef()
    this.resourceName = this.props.contractLike ? "contract" : "reservation"
  }

  handleInputChange(event) {
    handleInputChange(this, event)
  }

  handleArrivalChange(arrival) {
    this.setState({ arrival: moment(arrival).format("YYYY-MM-DD") })
  }

  handleDepartureChange(departure) {
    this.setState({ departure: moment(departure).format("YYYY-MM-DD") })
  }

  updateFeesAndDiscounts(newFeesAndDiscounts) {
    this.setState({ feesAndDiscounts: newFeesAndDiscounts })
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  save() {
    this.setState({ saving: true })
    if (!this.hasUnsavedFeeOrDiscount()) {
      const params = {
        check_in_date: this.state.arrival,
        check_out_date: this.state.departure,
        boater_notification: this.state.boaterNotification,
        requested_space_type: this.state.spaceType,
        revenue_category_id: this.state.revenueCategoryId,
        rate: {
          fees_and_discounts: JSON.stringify(this.state.feesAndDiscounts),
        },
        _method: "patch",
      }
      $.post(this.props.endpoint, params, () => {
        location.reload()
      }).fail((data) => {
        this.setState({
          errorMessage:
            data?.responseJSON?.error || `Error updating ${this.resourceName}.`,
          saving: false,
        })
      })
    } else {
      this.setState({ saving: false })
    }
  }

  hasUnsavedFeeOrDiscount() {
    return this.feesAndDiscountsRef.current?.hasUnsavedChanges() || false
  }

  render() {
    return (
      <div className="inline-block">
        <button
          type="button"
          className={`btn ${
            this.props.buttonClass || "btn-secondary btn-with-icon"
          }`}
          onClick={this.openModal}
        >
          {!this.props.buttonClass && (
            <i className="fa-kit fa-edit hidden md:inline" />
          )}
          Edit
        </button>
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="large"
        >
          <Modal.Header title={`Edit ${titleCase(this.resourceName)}`} />

          <Modal.Body>
            <ItinerarySection
              arrival={this.state.arrival}
              departure={this.state.departure}
              startName="Start Date"
              endName="End Date"
              spaceType={this.state.spaceType}
              spaceTypes={this.props.marinaSpaceTypes}
              disabledSpaceType={this.props.isContract}
              handleInputChange={this.handleInputChange}
              handleArrivalChange={this.handleArrivalChange}
              handleDepartureChange={this.handleDepartureChange}
              disableDepartureDate={this.props.autoRenewEnabled}
              disabledRevenueCategory={this.props.disableRevenueCategory}
              revenueCategories={this.props.revenueCategories}
              revenueCategoryId={this.state.revenueCategoryId}
              autoRenewEnabled={this.props.autoRenewEnabled}
              disableAutoRenewEndPoint={this.props.disableAutoRenewEndPoint}
              editReservationModalOpen={this.state.showModal}
            />
            <hr />
            <FeesAndDiscountsForm
              ref={this.feesAndDiscountsRef}
              updateFeesAndDiscounts={this.updateFeesAndDiscounts}
              feesAndDiscounts={this.state.feesAndDiscounts}
              feeCategories={this.props.feeCategories}
              pricingStructure={this.props.pricingStructure}
              startDate={this.state.arrival}
              endDate={this.state.departure}
              colWidth="col-xs-12"
            />
            <ErrorMessage>{this.state.errorMessage}</ErrorMessage>
            <hr />
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  name="boaterNotification"
                  checked={this.state.boaterNotification}
                  onChange={this.handleInputChange}
                />
                Send Email Update to Boater
              </label>
            </div>
            <div className="font-semibold text-teal-700">
              Changes to dates or fees and discounts on this {this.resourceName}{" "}
              will affect the final price accordingly.
            </div>
          </Modal.Body>

          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText={`Update ${titleCase(this.resourceName)}`}
            confirmBtnLoading={this.state.saving}
            onClose={this.closeModal}
            onSubmit={this.save}
          />
        </Modal>
      </div>
    )
  }
}

EditReservationModal.propTypes = {
  arrival: PropTypes.string.isRequired,
  departure: PropTypes.string.isRequired,
  revenueCategoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  feesAndDiscounts: PropTypes.array,
  spaceType: PropTypes.string,
  contractLike: PropTypes.bool,
  buttonClass: PropTypes.string,
  endpoint: PropTypes.string.isRequired,
  marinaSpaceTypes: PropTypes.array.isRequired,
  isContract: PropTypes.bool,
  autoRenewEnabled: PropTypes.bool,
  disableRevenueCategory: PropTypes.bool,
  revenueCategories: PropTypes.array,
  disableAutoRenewEndPoint: PropTypes.string,
  feeCategories: PropTypes.array.isRequired,
  pricingStructure: PropTypes.string.isRequired,
}

export default EditReservationModal
